import React from 'react'
import { Create } from 'react-admin'
import SectionWrapper from 'ui-shared/LayoutComponents/SectionWrapper'
import BasePackageForm from '../BasePackageForm'

const RentPackageCreate: React.FC = () => (
  <SectionWrapper title={'resources.rentpackages.createPackage'}>
    <Create>
      <BasePackageForm entity="rents" />
    </Create>
  </SectionWrapper>
)

export default RentPackageCreate
